import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-document.png'

const DocumentIcon = (props: any) => {
  return <BaseIcon img={img} size={props.size} />
}

export default DocumentIcon
